import type { VodWithPrice } from '@/interfaces'
import { extendMediaItemByLabelPrice } from '@/tools'
import type { CarouselItem, CarouselItemTyped } from '@setplex/tria-api'
import { type AdjustPurchaseableFn } from '~/features/payment/sse-purchases'

export const formatFeaturedRowVods = (
  items: CarouselItem[],
  adjust: AdjustPurchaseableFn
): CarouselItemTyped<VodWithPrice>[] => {
  return items.map((item: CarouselItem): CarouselItemTyped<VodWithPrice> => {
    return {
      ...item,
      vod:
        item.vod &&
        (extendMediaItemByLabelPrice(adjust(item.vod)) as VodWithPrice),
    }
  })
}
